import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/acehighway/abiInbondEvent'
import pathMap from 'src/paths/pathMap'

class AceHwyAbiInbondEventRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.ABI_INBOND_EVENT_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.ABI_INBOND_EVENT_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.ABI_INBOND_EVENT_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.ABI_INBOND_EVENT_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}
export default AceHwyAbiInbondEventRoute
